<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
<path d="M5 5.75H15.25V14.5C15.25 16.8472 13.3472 18.75 11 18.75H9.25C6.90279 18.75 5 16.8472 5 14.5V5.75Z" stroke="currentColor" stroke-width="1.9"/>
<path d="M15.5 8.25H16.75C18.5449 8.25 20 9.70507 20 11.5C20 13.2949 18.5449 14.75 16.75 14.75H15.5" stroke="currentColor" stroke-width="1.9"/>
</svg>
